// @flow

import React from 'react';

import type {
  ProductVariantOptionValue,
  ProductVariantOptionImageShape,
  ProductVariantOptionDisplayType,
} from '../../../../entities';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {getImageUrl} from '../../../../utils/image_provider';

type Props = {
  imageShape: ProductVariantOptionImageShape,
  value: ProductVariantOptionValue,
  displayType: ProductVariantOptionDisplayType,
};

const useStyles = props =>
  makeStyles(theme => ({
    root: {
      border: `1px solid ${colors.grey300}`,
      padding: theme.spacing(1),
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    name: {
      fontSize: 14,
      color: '#55556D',
    },
    preview: {
      width: 20,
      height: 20,
      borderRadius: props.rounded ? '100%' : 0,
      backgroundColor: props.background,
      '& img': {
        objectFit: 'cover',
        maxWidth: '100%',
        width: '100%',
        height: '100%',
        maxHeight: '100%',
      },
    },
  }));

const VariantOptionValueItem = ({value, displayType, imageShape}: Props) => {
  const shouldShowPreview = displayType !== 'TEXT';

  const isColor = displayType === 'COLOR';
  const isImage = displayType === 'IMAGE';

  const classes = useStyles({
    rounded: imageShape === 'CIRCULAR',
    background: isColor ? value.color : undefined,
  })();

  const buildPreview = () => {
    return (
      <div className={classes.preview}>
        {isImage && <img src={getImageUrl(value.imageId)} alt="" />}
      </div>
    );
  };

  return (
    <div className={classes.root}>
      {shouldShowPreview && buildPreview()}
      <Typography className={classes.name}>{value.label}</Typography>
    </div>
  );
};

export default VariantOptionValueItem;
